import { render, staticRenderFns } from "./VenN_Details.vue?vue&type=template&id=b8c39f64"
import script from "./VenN_Details.vue?vue&type=script&lang=js"
export * from "./VenN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports